import { render, staticRenderFns } from "./SubMainApp.vue?vue&type=template&id=7fbad7b8&"
import script from "./SubMainApp.vue?vue&type=script&lang=js&"
export * from "./SubMainApp.vue?vue&type=script&lang=js&"
import style0 from "./SubMainApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports